import Flickity from "flickity";
import { fetchProductsById } from "../services/products";
import { attachProductItemEvents, getProductItemBody, renderVideos } from "../common/product-item";
import 'flickity/dist/flickity.min.css';
import Collapsable from "../lib/Collapsable";
import { scrollToElement } from "../utils/dom";
import { waitObjectProperty } from "../utils/performance";

const mobileMedia = window.matchMedia('screen and (max-width: 768px)');


const LooksClass = function (id) {
  this.id = id
  this.state = {
    elements: {},
    settings: null,
    products: {},
    looksSlider: null,
    productsSlider: null,
    renderedProductsState: {},
    activeLookView: null,
    draggingLooks: false,
    collapsable: null,
    scrollInterval: {
      body: {
        previous: false,
        next: false,
      },
      products: {
        previous: false,
        next: false,
      }
    },
  }

  this.init()
}

const lp = LooksClass.prototype

lp.init = async function() {
  this.cacheElements(),
  this.state.elements.looksContainer
  && window.looksSettings[this.id]?.products && (
    this.initPreviewLooksSlider(),
    await this.attachListeners(),
    await this.fetchLookProductsById(),
    await this.initFirstProductsSlider()
  )
};

lp.attachListeners = async function() {
  const slides = this.state.looksSlider.getCellElements();
  slides.forEach((slide) => {
    slide.addEventListener('click', this.onOpenLook.bind(this));
  });
  this.state.looksSlider.on('dragMove', this.onStartDrag.bind(this));
  this.state.elements.closeBtn.addEventListener('click', this.closeLook.bind(this));
  mobileMedia.onchange = await this.initFirstProductsSlider.bind(this);
};

lp.cacheElements = function () {
  const looksContainer = document.querySelector(`#section-wrapper-${this.id} .looks`);
  if (!looksContainer) return;
  const looksContent = looksContainer.querySelector('.looks__content');
  const { settings } = looksContainer.dataset;
  this.state.settings = settings;
  this.state.elements = {
    ...this.state.elements,
    looksContainer,
    productsContainer: looksContent.querySelector('.looks__products'),
    closeBtn: looksContainer.querySelector('.looks__close-btn'),
    looksContent,
    looksBodyPrev: looksContainer.querySelector('.looks__body--prev'),
    looksBodyNext: looksContainer.querySelector('.looks__body--next'),
    looksProductPrev: looksContainer.querySelector('.looks__products--prev'),
    looksProductNext: looksContainer.querySelector('.looks__products--next'),
  };
}

lp.onStartDrag = function(){this.state.draggingLooks = true}

lp.replaceProductsContainer = function() {
  if (!this.state.productsSlider) return;
  this.state.elements.productsContainer.remove();
  const newContainer = document.createElement('div');
  newContainer.className = 'looks__products carousel';
  this.state.elements.productsContainer = newContainer;
  this.state.elements.looksContent.insertAdjacentElement('beforeend', newContainer);
};

lp.initProductsSlider = function(products) {
  const productsCount = (
    products || 
    Object.values(this.state.products)[0]
  )?.length;

  if (mobileMedia.matches || productsCount < 4) {
    return;
  }
  this.state.productsSlider = new Flickity(
    `#section-wrapper-${this.id} .looks__products`,
    {
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'center',
      wrapAround: true,
      // on: {
      //   ready: () => {
      //     const {looksProductPrev, looksProductNext} = this.state.elements;
      //     looksProductPrev.addEventListener(
      //       'mouseenter', 
      //       this.autoPlaySliderOnHover
      //         .bind(this,'previous', "productsSlider", "products")
      //     )
      //     looksProductNext.addEventListener(
      //       'mouseenter', this.autoPlaySliderOnHover
      //         .bind(this, 'next', "productsSlider", "products")
      //     )
      //     looksProductPrev.addEventListener(
      //       'mouseout', this.stopScrollInterval
      //         .bind(this,'previous', "products")
      //     )
      //     looksProductNext.addEventListener(
      //       'mouseout', this.stopScrollInterval
      //         .bind(this, 'next', "products")
      //     )

      //   }
      // }
    },
  );
};

lp.initFirstProductsSlider = async function() {
  const products = Object.values(this.state.products);
  if (!products.length) return;
  this.replaceProductsContainer();
  this.initProductsSlider(products);
  await this.renderProductItemTemplates(products[0]);
  this.initCollapsable();
  this.state.activeLookView = null;
  this.state.draggingLooks = false;
};

lp.initCollapsable = function() {
  if (this.state.collapsable) return;
  this.state.collapsable = new Collapsable({
    container: this.state.elements.looksContainer,
    element: this.state.elements.looksContent,
    toggler: this.state.elements.closeBtn,
    resetMedia: mobileMedia,
    onTransitionEnd: (_event, isOpen) => {
      scrollToElement(
        isOpen ? `#section-wrapper-${this.id} .looks__content` : `#section-wrapper-${this.id} .looks`,
        isOpen ? 0 : 25,
        !isOpen,
      );
    },
  });
};

lp.renderProductItemTemplates = async function(products) {
  if (!products.length) return;
  await waitObjectProperty("GLBE_PARAMS", window)
  if (GLBE_PARAMS.currencyCode !== "USD") {
    await waitObjectProperty("PriceInfo", window.GLBE_PARAMS)
  } 
  this.state.renderedProductsState = {};
  const { productsContainer, looksContent } = this.state.elements;
  const productItemTemplates = products.map((product, index) => {
    const newProduct = {...product}
    if (GLBE_PARAMS.currencyCode !== "USD") {
      newProduct.price = glbeApp.modules.priceInfo.convertPrice(newProduct.price)
      if (newProduct.compareAtPrice) {
        newProduct.compareAtPrice = glbeApp.modules.priceInfo.convertPrice(newProduct.compareAtPrice)
      }
    }
    return `
    <div class="carousel-cell looks__product-item">
      ${getProductItemBody(
        newProduct,
        index,
        this.state.renderedProductsState,
        false,
        productsContainer
      )}
    </div>
  `.trim()
  });
  if (mobileMedia.matches || products.length < 4) {
    productsContainer.innerHTML = productItemTemplates.join('');
  } else {
    const copiedContainer = productsContainer.cloneNode(true);
    productsContainer.remove();
    looksContent.insertAdjacentElement('beforeend', copiedContainer);
    this.state.elements.productsContainer = copiedContainer;
    const tempElement = document.createElement('template');
    tempElement.insertAdjacentHTML('afterbegin', productItemTemplates.join('').trim());
    this.initProductsSlider(products);
    this.state.productsSlider.remove(this.state.productsSlider.getCellElements());
    tempElement.innerHTML = productItemTemplates.join('').trim();
    const productItemEls = tempElement.querySelectorAll(
      '.carousel-cell.looks__product-item'
    );
    this.state.productsSlider.append(productItemEls);
    this.state.productsSlider.reloadCells();
  }
  attachProductItemEvents(
    this.state.renderedProductsState, 
    this.state.elements.productsContainer
  );
  await renderVideos(products, this.state.renderedProductsState);
};

lp.closeLook = function() {
  this.state.renderedProductsState = {};
  this.state.elements.looksContainer.classList.remove('active');
  this.state.activeLookView = null;
};

lp.onOpenLook = async function(e) {
  if (this.state.draggingLooks) {
    this.state.draggingLooks = false;
    return;
  }
  const { currentTarget } = e;
  const { blockId } = currentTarget.dataset;
  if (this.state.activeLookView && this.state.activeLookView === blockId) {
    return;
  }
  const productsList = this.state.products[blockId];
  if (!productsList) return;
  await this.renderProductItemTemplates(productsList);
  this.state.collapsable.open();
  this.state.elements.looksContainer.classList.add('active');
  this.state.activeLookView = blockId;
};

lp.initPreviewLooksSlider = function() {
  this.state.looksSlider = new Flickity(
    `#section-wrapper-${this.id} .looks__body.carousel`,
    {
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      // on: {
      //   ready: () => {
      //     const {looksBodyPrev, looksBodyNext} = this.state.elements;
      //     looksBodyPrev.addEventListener(
      //       'mouseenter', 
      //       this.autoPlaySliderOnHover
      //         .bind(this,'previous', "looksSlider", "body")
      //     )
      //     looksBodyNext.addEventListener(
      //       'mouseenter', this.autoPlaySliderOnHover
      //         .bind(this, 'next', "looksSlider", "body")
      //     )
      //     looksBodyPrev.addEventListener(
      //       'mouseout', this.stopScrollInterval
      //         .bind(this,'previous', "body")
      //     )
      //     looksBodyNext.addEventListener(
      //       'mouseout', this.stopScrollInterval
      //         .bind(this, 'next', "body")
      //     )

      //   }
      // }
    },
  );
};

// lp.autoPlaySliderOnHover = function(direction, carouselName, carouselInterval) {
//   const carousel = this.state[carouselName]
//   this.stopScrollInterval(direction, carouselInterval)
//   const scrollCarousel = function() {carousel[direction](true)}

//   scrollCarousel()
//   this.state.scrollInterval[carouselInterval][direction] = setInterval(scrollCarousel.bind(this), 1500)
// }

lp.stopScrollInterval = function(direction, carouselInterval) {
  clearInterval(this.state.scrollInterval[carouselInterval][direction])
}

lp.fetchLookProductsById = async function() {
  const { products } = window.looksSettings[this.id];
  const blockKeys = Object.keys(products);
  if (!blockKeys.length) return;
  const fetchedProducts = {};
  const promises = blockKeys.map(async (blockId) => {
    fetchedProducts[blockId] = await fetchProductsById(products[blockId]);
    return fetchedProducts[blockId];
  });
  await Promise.all(promises);
  this.state.products = fetchedProducts;
};


const init = () => {
  const lookSettings = window?.looksSettings
  if (!lookSettings) return
  const sections = Object.keys(lookSettings)
  sections.forEach(sectionID => {
    new LooksClass(sectionID)
  })
}

export default init;